import { PolitikerSettings } from '../objects/PolitikerSettings';
import { TromanError } from '../../common/TromanError';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
 */

export class PolitikerEndpoint {
    /**
     * 
     * @param {string} url
     * @param {ApiService} api
     */
    constructor(url, api) {
        this.url = url;
        this._api = api;
    }

    getSettings() {
        var dst = this.url + '/settings';
        return this._api.getResponse(dst)
            .then(rsp => rsp.parseEntity(PolitikerSettings));
    }

    setPeriod(settings) {
        if (!(settings instanceof PolitikerSettings)) throw new TromanError("invalid_parameter");

        if (settings.Id) {
            return this._api.putVoid(this.url + '/settings/' + encodeURIComponent(settings.Id), settings).then(() => settings.Id);
        } else {
            return this._api.postResponse(this.url + '/settings', settings).then(x => x.getResult());
        }
    }

    removePeriod(id) {
        return this._api.postVoid(this.url + '/settings/' + encodeURIComponent(id) + '/delete');
    }
}

